/* Angular libraries */
require('angular-resource');
require('angular-ui-router');

require('./core.module.js');

/* Services */
require('./services/form-errors.service.js');
require('./services/http-intercepter.service.js');
require('./services/session.service.js');

/* Filters */
require('./filters/bytes.filter.js');
require('./filters/capitalize.filter.js');
require('./filters/date-range.filter.js');
require('./filters/trust-as-html.filter.js');
require('./filters/normalize-message-type.filter.js');
require('./filters/normalize-status-staff.filter.js');
require('./filters/normalize-status-customer.filter.js');
